import React from 'react';
import { SUBJECT_PALETTE, orderedSubjectKeys } from '../constants';

const toRoman = (num) => {
    if (!num) return 'I';
    const lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1};
    let roman = '', i;
    for ( i in lookup ) {
      while ( num >= lookup[i] ) {
        roman += i;
        num -= lookup[i];
      }
    }
    return roman;
};

const AchievementBadge = ({ subject, chapterIndex, size = 60, locked = false }) => {
    const subjIndex = orderedSubjectKeys.indexOf(subject);
    const baseColor = subjIndex >= 0 ? SUBJECT_PALETTE[subjIndex] : '#2E5175';
    
    // Define the style for the container to handle grayscale
    const badgeStyle = {
        filter: locked ? 'grayscale(1) opacity(0.4)' : 'none',
        transition: 'filter 0.3s ease'
    };

    const numeral = toRoman(chapterIndex);

    return (
        <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" style={badgeStyle}>
            <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
                <feDropShadow dx="0" dy="4" stdDeviation="4" floodOpacity="0.15"/>
            </filter>
            <path 
                d="M50 95C50 95 10 75 10 30L50 5L90 30C90 75 50 95 50 95Z" 
                fill={baseColor} 
                stroke={locked ? "rgba(255,255,255,0.3)" : "white"} 
                strokeWidth="2"
                filter={locked ? "" : "url(#shadow)"}
            />
            {!locked && (
                <path d="M50 5L90 30C90 75 50 95 50 95V5Z" fill="white" fillOpacity="0.1" />
            )}
            <text 
                x="50" y="62" textAnchor="middle" fill="#fff" 
                fontFamily="'Source Serif 4', serif" fontWeight="800" fontSize="40"
                style={{textShadow: locked ? 'none' : '0 2px 4px rgba(0,0,0,0.3)'}}
            >
                {numeral}
            </text>
        </svg>
    );
};

export default AchievementBadge;